// src/utils/sound.js — efekte tingujsh me Web Audio (pa skedarë audio).
// Autoplay: AudioContext-i "shkyçet" me gjestin e parë të përdoruesit (klik/prekje/tast).
let ctx = null;
function ac() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
}
function unlock() {
  const c = ac();
  if (c && c.state === 'suspended') c.resume();
}
if (typeof window !== 'undefined') {
  ['pointerdown', 'touchstart', 'keydown', 'click'].forEach((ev) =>
    window.addEventListener(ev, unlock, { passive: true })
  );
}
function tone(freq, dur, type, vol, delay) {
  const c = ac();
  if (!c) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  o.connect(g);
  g.connect(c.destination);
  const t = c.currentTime + (delay || 0);
  g.gain.setValueAtTime(vol, t);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.start(t);
  o.stop(t + dur + 0.03);
}
export const sound = {
  start()  { tone(523, 0.12, 'sine', 0.25, 0); tone(784, 0.18, 'sine', 0.25, 0.12); },
  reveal() { tone(659, 0.12, 'triangle', 0.25, 0); tone(880, 0.20, 'triangle', 0.25, 0.12); },
  tick()   { tone(880, 0.05, 'square', 0.10, 0); },
};
